import React from 'react';

const PageHero = ({ title, subtitle, backgroundImage, overlay = true }) => {
  return (
    <section className="relative h-[42vh] md:h-[52vh] min-h-[320px] md:min-h-[420px] flex items-end md:items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat img-treatment scale-105"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      {overlay && (
        <div className="absolute inset-0 bg-gradient-to-t from-brand-petrol via-brand-petrol/50 to-brand-petrol/20" />
      )}

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 md:pb-0 text-center md:text-left animate-subtle-rise">
        <h1 className="font-display text-3xl md:text-5xl lg:text-6xl text-white mb-3 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="font-display italic text-lg md:text-2xl text-brand-terracotta-light">
            {subtitle}
          </p>
        )}
        <div className="mt-6 mx-auto md:mx-0 h-px w-16 bg-brand-terracotta" />
      </div>

      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 80"
          className="w-full h-10 md:h-14 fill-brand-ivory"
          preserveAspectRatio="none"
        >
          <path d="M0,80 C360,10 1080,10 1440,80 L1440,80 L0,80 Z" />
        </svg>
      </div>
    </section>
  );
};

export default PageHero;
